import { render } from "./filtrosStatusTrocaSelectComponent.vue?vue&type=template&id=8718d13a&scoped=true"
import script from "./filtrosStatusTrocaSelectComponent.vue?vue&type=script&lang=js"
export * from "./filtrosStatusTrocaSelectComponent.vue?vue&type=script&lang=js"

import "./filtrosStatusTrocaSelectComponent.vue?vue&type=style&index=0&id=8718d13a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8718d13a"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel,QTooltip,QField});
